import { toast } from 'sonner';
import i18next from 'i18next';

/**
 * Read-only registry for workflow TRIGGER event dropdowns (no success toasts on GET).
 */
export class EntityEventIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }

    async getEventsForEntityType(entityType) {
        if (!entityType?.trim()) {
            return { success: true, data: [] };
        }
        try {
            const r = await this.service.getEventsForEntityType(entityType.trim());
            return { success: true, data: Array.isArray(r.data) ? r.data : [] };
        } catch (error) {
            const msg = error.message || i18next.t('common:messages.unexpectedError');
            toast.error(msg);
            return { success: false, error: msg, data: [] };
        }
    }
}
